import React from 'react';
import PropTypes from 'prop-types';
import { DropdownItem } from '@comparethemarketau/manor-dropdown';
import { connect } from 'react-redux';

import classNames from 'classnames';

import { StyledManorDropdown } from './styled_manor_dropdown';
import { paymentFrequencyStateMapping, paymentFrequencyDispatchMapping, frequencyFilterTypes } from './filter_store_mapping';

const _PaymentFrequencyFilterDropdown = (props) => {
    const { className, frequencyFilter, sortResults, setFrequencyFilter, isWithoutLabel, options } = props;

    const label = 'PAYMENT FREQUENCY';
    const tooltipContent = {
        trackingLabel: 'tooltip for payment frequency',
        body: 'Choose between paying monthly or annually. You may save money with some providers by paying annually.'
    };

    const handleFrequencyChange = (event, value, option) => {
        if (value === frequencyFilter) {
            return;
        }
        sortResults(value);
        setFrequencyFilter(value);
    };

    return (
        <div className={classNames('test-policyFilters-paymentFrequency')}>
            <StyledManorDropdown
                key={`payment-frequency-dropdown-${frequencyFilter}`}
                trackingLabel="Payment Frequency Filter"
                label={!isWithoutLabel && label}
                variant="text"
                selectedValue={frequencyFilter}
                handleChange={handleFrequencyChange}
                className={className}
                tooltip={tooltipContent}
            >
                <DropdownItem value="annual">{options.annual}</DropdownItem>
                <DropdownItem value="monthly">{options.monthly}</DropdownItem>
            </StyledManorDropdown>
        </div>
    );
};

_PaymentFrequencyFilterDropdown.propTypes = {
    className: PropTypes.string,
    frequencyFilter: PropTypes.oneOf(frequencyFilterTypes),
    sortResults: PropTypes.func.isRequired,
    setFrequencyFilter: PropTypes.func.isRequired,
    options: PropTypes.shape({
        annual: PropTypes.string,
        monthly: PropTypes.string
    }),
    isWithoutLabel: PropTypes.bool
};

_PaymentFrequencyFilterDropdown.defaultProps = {
    options: {
        annual: 'Annually',
        monthly: 'Monthly'
    }
};

const PaymentFrequencyFilterDropdown = connect(paymentFrequencyStateMapping, paymentFrequencyDispatchMapping)(_PaymentFrequencyFilterDropdown);

export { PaymentFrequencyFilterDropdown };
